import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import styles from '../../styles/AppStyles';
import { Classification } from '../types/LandingPageTypes';
import Checkbox from './Checkbox';

interface TemplateFromScratchProps {
  fromScratchMode: boolean;
  setFromScratchMode: (val: boolean) => void;
}

const TemplateFromScratch: React.FC<TemplateFromScratchProps> = ({
    fromScratchMode,
    setFromScratchMode,
}) => {
  return (
    <View style={styles.sectionWrapper}>
      <Text style={styles.sectionTitle}>Mode</Text>
      <View>
        <ScrollView style={styles.researchScroll}>
        <Checkbox
                label="Generate Template from Scratch (Premium)"
                checked={fromScratchMode}
                onChange={setFromScratchMode}
                />
        </ScrollView>
      </View>
    </View>
  );
};

export default TemplateFromScratch;